import { mapEnumToOptions } from '@abp/ng.core';

export enum IncrementStatisticTimeInterval {
  Daily = 0,
  Weekly = 1,
  Monthly = 2,
}

export const incrementStatisticTimeIntervalOptions = mapEnumToOptions(IncrementStatisticTimeInterval);
